/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.WalkinManager.AddToWaitlist {

    import Employee = Meevo.Model.Employee;
    import EmployeeSearchView = Meevo.Model.EmployeeSearchView;
    import EmployeeGenderSearchEnum = Meevo.Model.EmployeeGenderSearchEnum;

    interface EmployeeSearchCriteria {
        serviceId?: string,
        eligibleForWalkinManager?: boolean,
        walkinAppointmentSearchView?: Meevo.Model.WakinAppointmentSearchView,
        view: EmployeeSearchView,
        fetchEmployeePicture?: boolean
    }

    export interface IEmployeeList {
        employees: Array<Employee>;
        currentEmployee: Employee;
        currentEmployeeName: string;
        currentEmployeePreference: EmployeeGenderSearchEnum;
        fetchEmployees: any;
        searchCriteria: EmployeeSearchCriteria;
        getEmployeeById: Function;
        clear: Function;
    }

    export class EmployeeList implements IEmployeeList {
        _currentEmployee: Employee;
        _employeeList: Array<Employee>;
        _searchCriteria: EmployeeSearchCriteria;

        private _currentEmployeePreference: EmployeeGenderSearchEnum;

        get currentEmployeePreference(): EmployeeGenderSearchEnum {
            return this._currentEmployeePreference;
        }

        set currentEmployeePreference(preference: EmployeeGenderSearchEnum) {
            this._currentEmployeePreference = preference;
        }

        constructor (
            protected $q: ng.IQService,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            currentEmployee?: Employee,
            employeeList?: Array<Employee>,
            searchCriteria?: EmployeeSearchCriteria
        ) {
            this.currentEmployee = currentEmployee || null;
            this.employees = employeeList || [];
            this.searchCriteria = searchCriteria || <EmployeeSearchCriteria>({});
            this.currentEmployeePreference = null;
        }

        fetchEmployees(getClockedInEmployees: boolean = false) {
            this.busyService.start();
            let deferred = this.$q.defer();

            this.dataService.getListPaged('employee', {
                criteria: this.searchCriteria,
                itemsPerPage: 1000,
            })
                .then(result => {
                    if (getClockedInEmployees) {
                        this.dataService.customMethodData('api/TimeClock/EmployeesClockedIn', 'POST', { employees: result })
                            .then((clockedResult: any) => {
                                let emps = <Array<any>>clockedResult.data;
                                this.employees = result.filter((emp: Employee) => {
                                    return _.some((emps), (status) => {
                                        return status.id === emp.id;
                                    });
                                });
                                deferred.resolve();
                            })
                            .catch(() => deferred.reject());
                    } else {
                        this.employees = result;
                        deferred.resolve();
                    }
                })
                .catch(() => deferred.reject())
                .finally(() => {
                    this.busyService.stop();
                });

            return deferred.promise;
        }

        clear(): void {
            this.currentEmployee = null;
            this.employees.length = 0;
            this.currentEmployeePreference = null;
        }

        getEmployeeById (id: Guid): ng.IPromise<any> {
            let deferred = this.$q.defer();

            this.dataService.getItem('employee', id)
                .then((employee: Employee) => {
                    this.currentEmployee = employee;
                    deferred.resolve();
                })
                .catch(() => {
                    deferred.reject();
                });

            return deferred.promise;
        }

        get employees(): Array<Employee> {
            return this._employeeList;
        }

        set employees(data: Array<Employee>) {
            this._employeeList = data;
        }

        get currentEmployee(): Employee {
            return this._currentEmployee;
        }

        set currentEmployee(employee: Employee) {
            this._currentEmployee = employee;
        }

        get currentEmployeeName(): string {
            let name = '',
                currentEmployee = this._currentEmployee;

            if (currentEmployee) {
                if (currentEmployee.nickName) {
                    name = currentEmployee.nickName;
                } else {
                    name = currentEmployee.employeeCode;
                }
            }

            return name;
        }

        get searchCriteria(): EmployeeSearchCriteria {
            return this._searchCriteria;
        }

        set searchCriteria(criteria: EmployeeSearchCriteria) {
            criteria.eligibleForWalkinManager = true;

            this._searchCriteria = criteria;
        }

        static factory(): Function {
            let svc = (
                $q: ng.IQService,
                dataService: Meevo.Components.BaseClasses.IDataService,
                busyService: Meevo.Components.Busy.IBusyService
            ) => {
                return new EmployeeList($q, dataService, busyService);
            };

            svc.$inject = [
                '$q',
                'meevo.components.common.DataService',
                'meevo.components.busy.BusyService'
            ];
            return svc;
        }
    }

    angular.module("meevo.plugins.walkinManager")
        .service('meevo.plugins.walkinManager.addToWaitlist.employeeListService', EmployeeList.factory());
}
